var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chat',{attrs:{"id_evento":_vm.id_evento,"es_coach":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }